import * as types from './mutation-types'

export default {
    [types.SET_CURRENT_COMPONENT](state, currentComponent) {
        state.currentComponent = currentComponent
    },
}